var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInicio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16671 24.5H19.8334M4.66671 3.5H23.3334C24.622 3.5 25.6667 4.54467 25.6667 5.83333V17.5C25.6667 18.7887 24.622 19.8333 23.3334 19.8333H4.66671C3.37804 19.8333 2.33337 18.7887 2.33337 17.5V5.83333C2.33337 4.54467 3.37804 3.5 4.66671 3.5Z",
    stroke: "#060606",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInicio);
export default __webpack_public_path__ + "static/media/inicio.14134625cd3ae89d36429b1821b78224.svg";
export { ForwardRef as ReactComponent };